module.exports = __webpack_public_path__ + "img/Snow.525b9dc4.png";